import { STATIC_ASSETS_URL } from "common/context/constants"

import "../style.scss"

const NotificationsMenuNoData = () => {
  return (
    <img
      className='mb-5'
      src={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/sin_notificaciones.svg`}
      alt='Bicolor.svg'
    />
  )
}

export default NotificationsMenuNoData
